module.exports = __webpack_public_path__ + "static/data/library.8834559.json";